import { render, staticRenderFns } from "./FormMedia.vue?vue&type=template&id=6a85bacc&"
import script from "./FormMedia.vue?vue&type=script&lang=js&"
export * from "./FormMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports